import styled from 'styled-components';
import { merriweather } from 'styles/GlobalStyle';

const ImageContainer = styled.div`
    position: relative;
    font-size: 14px;
    font-family: ${merriweather.style.fontFamily};
`;

export default ImageContainer;
